import { fg } from '@atlaskit/platform-feature-flags/fg';

export const isCodeSearchEnabled = (): boolean => fg('rovo_t26_eu_code_search');

export const isLegacyCodeSearchEnabled = (): boolean =>
	!fg('rovo_t26_eu_code_search') && fg('rovo_github_code_search');

export const isAnyCodeSearchEnabled = (): boolean =>
	fg('rovo_t26_eu_code_search') || fg('rovo_github_code_search');
